// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jbIqMOv_M8MaLY998mhh{margin-bottom:2em}.jbIqMOv_M8MaLY998mhh h2,.jbIqMOv_M8MaLY998mhh h3,.jbIqMOv_M8MaLY998mhh li,.jbIqMOv_M8MaLY998mhh p,.jbIqMOv_M8MaLY998mhh ul{margin-bottom:1em}.jbIqMOv_M8MaLY998mhh ul{list-style:disc outside;padding-left:28px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contenttext": "jbIqMOv_M8MaLY998mhh"
};
export default ___CSS_LOADER_EXPORT___;
